import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { HandoverPage } from '@/features/handover/handover-page';

/** `step=account`: back from refreshing the owner's KorOS organisations. */
const searchSchema = z.object({
  step: z.enum(['account']).optional().catch(undefined),
});

/** Move to KorOS — also the target of the "handover finished" notification. */
export const Route = createFileRoute('/_app/projects/$projectId/handover')({
  validateSearch: searchSchema,
  component: HandoverRoute,
});

function HandoverRoute() {
  const { projectId } = Route.useParams();
  const { step } = Route.useSearch();
  return <HandoverPage projectId={projectId} initialStep={step} />;
}
